<template>
	<view class="box">
    <image :src="loginTop" class="topImg" mode="widthFix"></image>
    <view class="main">
      <view class="header">
        <view class="titleFirst">
          你好~<br/>欢迎来到安全教育平台</view>
      </view>
      <!-- <view class="form-area"> -->
        <u--form :model="form" ref="uForm" class="form" >
          <u-form-item>
			  <u--input v-model="form.username" :class="{'isFocused': userFocused}" placeholder="请输入用户名" @focus="focusUser()"/>
		  </u-form-item>
          <u-form-item style="margin-top: 10px" >
			<u-input v-model="form.password" :class="{'isFocused': codeFocused}" :password="codeType === 'password'" placeholder="请输入密码"  @focus="focusCode()">
				<template slot="suffix">
				  <u-icon :name="codeType == 'password'?'eye-fill':'eye-off'" color="#999" size="20" @tap.stop="viewCode()"></u-icon>
		<!-- 		  <u-icon v-show="codeType == 'text'" name="eye-off" color="#999" size="20" @click="viewCode"></u-icon> -->
				</template>
			</u-input>
		  </u-form-item>
          <!-- <view class="loginPsw">
                 <u-checkbox-group >
                <u-checkbox disabled="true"></u-checkbox><text style="color: #fff;">自动登录</text>
                 </u-checkbox-group>
                  <text style="color: lightblue;">忘记密码</text>
          </view> -->
          <u-form-item style="margin-top: 10px">
            <u-button class="loginBtn" :loading="isLogining" @click="Login" type="primary">登录</u-button>
          </u-form-item>
          <!--				<view style="color: white;margin-top: 150px;">技术支持：技术保障部</view>-->
        </u--form>
      <!-- </view> -->
    </view>

	</view>
</template>

<script>
	import {login,getLastApp} from '../../api/index.js';
	import store from '@/store/index.js'
	import VUE_APP_BASE_URL from '../../common/constant.js'
	// const jpushModule = uni.requireNativePlugin('JG-JPush')
  import loginTop from '../../static/loginTop1.png'
	export default {
		data() {
		return {
			loginTop: loginTop,
			userFocused: false,
			codeFocused: false,
			form: {
				username: '',
				password: '',
				  code: '',
				  uuid: ''
				},
			codeType: 'password',
					type: '',
					//极光推送
					connectStatus: '未连接',
					registrationID: '未获得',
					isLogining: false
				}
			},
		onShow() {
			if(uni.getStorageSync('name') && uni.getStorageSync('pwd')){
				// this.form.name = uni.getStorageSync('name');
				// this.form.pwd = uni.getStorageSync('pwd');
// 				if(uni.getStorageSync('roleName') == '工作人员'){
// 					this.$store.commit('setRoleId', 'user_other');
// 					uni.switchTab({
// 					     url: '/pages/tabBar/notice/notice'
// 					  });
// 				}else if (uni.getStorageSync('roleName') == '管理员'){
// 					this.$store.commit('setRoleId', '');
// 					uni.showToast({
// 						icon: "none",
// 						title: '管理员请使用平台登录'
// 					});
// 				}else{
// 					this.$store.commit('setRoleId', 'user_leader');
// 					uni.switchTab({
//                         url: '/pages/tabBar/firstPage/firstPage'
//                     });
// 				}
			}else{
				uni.clearStorageSync();
				uni.clearStorage();
			}
		},
		onLoad() {
			// this.connect()
			wx.showShareMenu({
			      withShareTicket: true,
			      menus: ['shareAppMessage', 'shareTimeline']
			    })
		},
		methods: {
		  base64Encode(e) {
			const utf8Bytes = unescape(encodeURIComponent(e));
				const array = new Uint8Array(utf8Bytes.length);
				for (let i = 0; i < utf8Bytes.length; i++) {
				  array[i] = utf8Bytes.charCodeAt(i);
				}
				return wx.arrayBufferToBase64(array);
		  },
			Login(){
				const t = this
        if(t.form.username == ''){
          uni.showToast({
            title: '请输入用户名',
            duration: 1000
          })
          return
        }
        if(t.form.password == ''){
          uni.showToast({
            title: '请输入密码',
            duration: 1000
          })
          return
        }
				t.isLogining = true;
        // this.form.password = this.base64Encode(this.form.password)
        const {username,password,code,uuid} = t.form
        const data = {username,password,code,uuid}
        data.password = t.base64Encode(data.password)
        uni.removeStorageSync('tk');
				login(data).then(res => {
					if (res.code === 200) {
						t.isLogining = false;
						 //登录成功后
						 //设置别名
						// jpushModule.setAlias({
						// 	'alias': this.phone,
						// 	'sequence': 1
						// })
						uni.setStorageSync("name", t.form.username);
						uni.setStorageSync("pwd", t.form.password);
						uni.setStorageSync("tk", res.data.token);
						uni.setStorageSync("uid",res.data.id);
						uni.setStorageSync('user', res.data);
						// t.$store.commit('setRoleId', 'user_leader');
						uni.switchTab({
							url: '/pages/tabBar/firstPage/firstPage'
						})
		// 				}
					}else{
						uni.showToast({
							icon: "none",
							title: res.message
						});
						t.form.password = '';
						t.isLogining = false;
					}
				}).catch(err=>{
					t.form.password = '';
					t.isLogining = false;
				})
			},
			connect() {
				uni.$on('connectStatusChange', (connectStatus) => {
					var connectStr = ''
					if (connectStatus == true) {
						connectStr = '已连接'
						this.getRegistrationID()
					} else {
						connectStr = '未连接'
					}
					console.log('监听到了连接状态变化 --- ', connectStr)
					this.connectStatus = connectStr
				})
			},
			//获取推送ID
			getRegistrationID() {
				jpushModule.getRegistrationID(result => {
					let registerID = result.registerID
					this.registrationID = registerID
					this.form.registrationId = registerID;
					uni.setStorageSync('registrationID', registerID);
					console.log("iddd",uni.getStorageSync('registrationID'))
				})
			},

      focusUser(){
        this.userFocused = true
        this.codeFocused = false
      },
      focusCode(){
        this.codeFocused = true
        this.userFocused = false
      },
      viewCode(){
        this.codeType = this.codeType === 'password' ? 'text' : 'password';
		
		this.focusCode()
		this.$nextTick();
      }
		}
	}
</script>

<style scoped lang="scss">
.box{
	width: 100%;
	height: 100vh;
    background: #f5f5f5;
	display: flex;
	flex-direction: column;
}

.topImg{
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 3px 5px rgba(21,148,232,.1))
}

.main{
  width: 100%;
  margin-top: 24rpx;
  padding: 0 40rpx;
  box-sizing: border-box;
}

.header {
	width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.titleFirst{
  width: 90%;
	font-size: 44rpx;
  line-height: 1.5;
  font-weight: bold;
  letter-spacing: 2px;
	color: #333;
}

::v-deep .u-form{
	margin-top: 40rpx;
}

::v-deep .u-input{
  border-color: #f5f5f5 !important;
  border-radius: 99px !important;
  background: #f5f5f5 !important;;
  padding: 15px 20px !important;
  box-shadow: 0px -6px 10px rgba(255, 255, 255, 1), 0px 4px 15px rgba(0, 0, 0, 0.1) !important;
  transition: box-shadow .1s ease !important;

  &:active{
    box-shadow: 0px -6px 10px rgba(255, 255, 255, 1), 0px 4px 15px rgba(0, 0, 0, 0.1),0px 3px 6px rgba(0, 0, 0, 0.1) inset !important;
  }
}

::v-deep .isFocused{
  background: #fff;
  border-width: 1px !important;
  border-color: #e6e6e6 !important;
  box-shadow: 0px -6px 10px rgba(255, 255, 255, 1), 0px 4px 15px rgba(0, 0, 0, 0.1),0px 3px 6px rgba(0, 0, 0, 0.1) inset !important;
}

.loginPsw{
	margin-bottom: 20px;
	display: flex;
	justify-content: space-between;
}

::v-deep .u-button{
  margin: 0 auto;
	height: 56px !important;
	border-radius: 99px !important;
  border: 1px solid rgba(255,255,255,.4) !important;
  letter-spacing: 10px !important;
  box-shadow: 0 2px 4px rgba(0,0,0,.2) !important;
  background-image: linear-gradient(#41a2ff,#0f7ff9) !important;
  transition: box-shadow .15s ease !important;
  font-size: 30rpx !important;
}

::v-deep .u-button:active{
  box-shadow: 0 2px 4px rgba(0,0,0,0) !important;
  background-image: linear-gradient(#0f7ff9,#41a2ff) !important;
}


</style>
